<ng-container *ngIf="dataSource | async as data">
	<div class="my-3 mx-4">
		<div class="d-flex justify-content-end me-5 my-4">
			<button class="mail-btn" (click)="openCreateMailDialog()" mat-raised-button color="primary">
				Utwórz maila
			</button>
		</div>
		<mat-card appearance="outlined">
			<mat-card-title>E-mail</mat-card-title>
			<mat-progress-bar *ngIf="loading; else table" mode="indeterminate"></mat-progress-bar>
			<ng-template #table>
				<mat-card-content>
					<h4 *ngIf="!data.length" style="text-align: center">Nie utworzono jeszcze żadnego wątku!</h4>
					<table *ngIf="data.length" mat-table [dataSource]="data">
						<ng-container matColumnDef="title">
							<th mat-header-cell *matHeaderCellDef>Tytuł</th>
							<td
								[ngClass]="{
									'fw-bold': element.unread > 0,
								}"
								mat-cell
								*matCellDef="let element"
							>
								{{ element.subject }}
							</td>
						</ng-container>

						<ng-container matColumnDef="createdAt">
							<th mat-header-cell *matHeaderCellDef>Utworzono</th>
							<td
								[ngClass]="{
									'fw-bold': element.unread > 0,
								}"
								mat-cell
								*matCellDef="let element"
							>
								{{ element.date | date: 'dd.MM.yyyy' }} |
								{{ element.date | date: 'HH:mm' }}
							</td>
						</ng-container>

						<ng-container matColumnDef="unread">
							<th mat-header-cell *matHeaderCellDef>Nieprzeczytane</th>
							<td mat-cell *matCellDef="let element">
								<div
									[ngClass]="{
										'bg-green': element.unread === 0,
									}"
									class="unread"
								>
									<span *ngIf="element.unread > 0">{{ element.unread }}</span>
									<i *ngIf="element.unread === 0" class="fas fa-check"></i>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="preview">
							<th mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let element">
								<div class="show-btn" (click)="openPreviewDialog(element)" role="button">
									<i class="fas fa-eye pe-1"></i><span>Zobacz</span>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="watch">
							<th mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let element">
								<div class="w-100 d-flex justify-content-end">
									<button
										class="d-flex justify-content-center align-items-center"
										(click)="changeWatchingState(element)"
										title="Obserwuj"
										mat-icon-button
									>
										<ng-container *ngIf="!loadingStates.get(element.id + '_watch'); else spinner">
											<i
												*ngIf="element.watching; else notWatching"
												style="color: #df0000"
												class="fas fa-heart"
											></i>
											<ng-template #notWatching>
												<i class="far fa-heart"></i>
											</ng-template>
										</ng-container>
										<ng-template #spinner>
											<mat-spinner diameter="20"> </mat-spinner>
										</ng-template>
									</button>
								</div>
							</td>
						</ng-container>

						<ng-container matColumnDef="archive">
							<th mat-header-cell *matHeaderCellDef></th>
							<td mat-cell *matCellDef="let element">
								<ng-container *ngIf="!loadingStates.get(element.id + '_archived'); else spinner">
									<button
										[title]="isArchived(element) ? 'Przywróć' : 'Archiwizuj'"
										mat-icon-button
										(click)="changeArchivedState(element)"
									>
										<i
											[ngClass]="isArchived(element) ? 'fa-undo-alt' : 'fa-archive'"
											class="fas"
										></i>
									</button>
								</ng-container>
								<ng-template #spinner>
									<mat-spinner diameter="20"> </mat-spinner>
								</ng-template>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
					</table>
				</mat-card-content>
			</ng-template>
		</mat-card>
	</div>
</ng-container>
